import { useTranslation } from "react-i18next";
//import TagLine from "./Tagline";

const Heading = ({ className, title, text, tag }) => {
  const { t } = useTranslation();
  return (
    <div
      className={`${className} max-w-[50rem] mx-auto mb-12 lg:mb-20 md:text-center`}
    >
   
      {title && <h2 className="h2  text-color-1 dark:text-tcolor-1">{t(title)}</h2>}
      {text && <p className="body-2 mt-4 text-tcolor-6 dark:text-n-4">{text}</p>}
    </div>
  );
};

export default Heading;
